import { TaskTypeSorting } from '@/tsort/enum/task-type-sorting.enum';
import { WorkInstruction } from '@/tsort/enum/work-instruction.enum';
import { WorkTypeSorting } from '@/tsort/enum/work-type-sorting.enum';
import { ScanSystemMenuResponse } from '@/tsort/model/response/scan-system-menu-response.model';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ScanSystemSetting } from '@/tsort/model/response/scan-system-setting.model';
import { ScanSystemField } from '@/tsort/model/response/scan-system-field.model';
import { ScanSettingResponse } from '../model/response/scan-setting-response.model';

export class SortStoreConst {
  public static readonly SORT_STORE_MODULE_NAME = 'SortStore';
}
const SORTING_STORAGE_NAME = 'SortStore';
@Module({ namespaced: true })
export default class SortStore extends VuexModule {
  // ローカル ストレージのデータ
  _sortingStorage: string | null = localStorage.getItem(SORTING_STORAGE_NAME);

  // セッション ストレージ内のデータ
  _sortingSessionStorage: string | null = sessionStorage.getItem(SORTING_STORAGE_NAME);

  // ローカル ストレージのデータ オブジェクトを解析する
  _sorting: ScanSystemMenuResponse = this._sortingStorage
    ? JSON.parse(this._sortingStorage)
    : {
        workInstruction: '',
        workType: '',
        rfidModeScanTarget: null,
        orderNumberModeScanTarget: '',
        taskType: '',
        displaySort: '',
        displayFlag: '',
        setting: {},
        field: [],
        scanCancelTaskServiceSettingVisibleFlag: false,
        multiSortChangedQuantityAlert: true,
        scanSetting: {}
      };

  // セッション ストレージ内のデータ オブジェクトを解析する
  _sortingSession: ScanSystemMenuResponse = this._sortingSessionStorage
    ? JSON.parse(this._sortingSessionStorage)
    : {
        wesNo: 0,
        lastChuteNo: '',
        rejectedTask: false
      };

  _currentScanSetting: ScanSettingResponse = {} as ScanSettingResponse;

  @Mutation
  public setWesNo(wesNo: number) {
    // let type = null;
    // if (typeof type === 'string') {
    //   type = Number.parseInt(type) as number;
    // } else {
    //   type = wesNo;
    // }
    this._sortingSession.wesNo = wesNo;
  }
  @Mutation
  public setLastChuteNo(lastChuteNo: string) {
    // this._lastChuteNo = lastChuteNo;
    // localStorage.setItem('lastChuteNo', lastChuteNo);
    this._sortingSession.lastChuteNo = lastChuteNo;
  }
  @Mutation
  public setRejectedTask(rejectedTask: boolean) {
    this._sortingSession.rejectedTask = rejectedTask;
  }

  @Mutation
  public setWorkInstruction(workInstruction: WorkInstruction) {
    let type = null;
    if (typeof type === 'string') {
      type = Number.parseInt(type) as WorkInstruction;
    } else {
      type = workInstruction;
    }
    this._sorting.workInstruction = type;
  }

  @Mutation
  public setWorkTypeSorting(workTypeSorting: WorkTypeSorting) {
    let type = null;
    if (typeof type === 'string') {
      type = Number.parseInt(type) as WorkTypeSorting;
    } else {
      type = workTypeSorting;
    }
    this._sorting.workType = type;
  }

  @Mutation
  public setTaskTypeSorting(taskTypeSorting: TaskTypeSorting) {
    let type = null;
    if (typeof type === 'string') {
      type = Number.parseInt(type) as WorkTypeSorting;
    } else {
      type = taskTypeSorting;
    }
    this._sorting.taskType = type;
  }

  @Mutation
  public updateSessionStorage(dataSessionStorage: ScanSystemMenuResponse) {
    sessionStorage.setItem(SORTING_STORAGE_NAME, JSON.stringify(dataSessionStorage));
  }

  @Mutation
  public updateStorage(scanSystemMenu: ScanSystemMenuResponse) {
    localStorage.setItem(SORTING_STORAGE_NAME, JSON.stringify(scanSystemMenu));
  }

  @Mutation
  public setScanSystemMenu(scanSystemMenu: ScanSystemMenuResponse) {
    this._sorting = {
      ...scanSystemMenu,
      lastChuteNo: this._sorting.lastChuteNo,
      wesNo: this._sorting.wesNo,
      rejectedTask: this._sorting.rejectedTask,
      rfidModeScanTarget: this._sorting.rfidModeScanTarget,
      orderNumberModeScanTarget: this._sorting.orderNumberModeScanTarget,
      scanSetting: this._sorting.scanSetting
    };
  }

  @Mutation
  public setSetting(scanSystemSetting: ScanSystemSetting) {
    this._sorting.setting = scanSystemSetting;
  }

  @Mutation
  public setFields(scanSystemField: Array<ScanSystemField>) {
    this._sorting.field = scanSystemField;
  }

  @Mutation
  public setRFIDModeScanTarget(rfidModeScanTarget: number) {
    this._sorting.rfidModeScanTarget = rfidModeScanTarget;
  }

  @Mutation
  public setOrderNumberModeScanTarget(orderNumberModeScanTarget: number) {
    this._sorting.orderNumberModeScanTarget = orderNumberModeScanTarget;
  }

  @Mutation
  public setScanSetting(scanSetting: ScanSettingResponse) {
    this._sorting.scanSetting = scanSetting;
  }

  @Mutation
  public setCurrentScanSetting(scanSetting: ScanSettingResponse) {
    this._currentScanSetting = scanSetting;
  }

  @Mutation
  public setInductionProcessingMode(inductionProcessingMode: boolean) {
    this._sorting.scanSetting = {
      ...this._sorting.scanSetting,
      inductionProcessingMode: inductionProcessingMode
    };
  }

  @Action({ rawError: true })
  public updateWesNo(wesNo: number): void {
    this.context.commit('setWesNo', wesNo);
    this.context.commit('updateSessionStorage', this._sortingSession);
  }
  @Action({ rawError: true })
  public updateLastChuteNo(lastChuteNo: string): void {
    this.context.commit('setLastChuteNo', lastChuteNo);
    this.context.commit('updateSessionStorage', this._sortingSession);
  }

  @Action({ rawError: true })
  public updateRejectedTask(rejectedTask: boolean): void {
    this.context.commit('setRejectedTask', rejectedTask);
    this.context.commit('updateSessionStorage', this._sortingSession);
  }

  @Action({ rawError: true })
  public updateWorkInstruction(value: WorkInstruction): void {
    this.context.commit('setWorkInstruction', value);

    this.context.commit('updateStorage', this._sorting);
  }

  @Action({ rawError: true })
  public updateWorkTypeSorting(value: WorkTypeSorting): void {
    this.context.commit('setWorkTypeSorting', value);
    this.context.commit('updateStorage', this._sorting);
  }

  @Action({ rawError: true })
  public updateTaskTypeSorting(value: TaskTypeSorting): void {
    this.context.commit('setTaskTypeSorting', value);
    this.context.commit('updateStorage', this._sorting);
  }

  @Action({ rawError: true })
  public resetTaskTypeInfo(): void {
    this.context.commit('setWorkInstruction', '');
    this.context.commit('setWorkTypeSorting', '');
    this.context.commit('setTaskTypeSorting', '');
    this.context.commit('updateStorage', this._sorting);
  }

  @Action({ rawError: true })
  public updateSetting(value: ScanSystemSetting): void {
    this.context.commit('setSetting', value);
    this.context.commit('updateStorage', this._sorting);
  }

  @Action({ rawError: true })
  public updateFields(values: ScanSystemField): void {
    this.context.commit('setFields', values);
    this.context.commit('updateStorage', this._sorting);
  }

  @Action({ rawError: true })
  public updateScanSystemMenu(value: ScanSystemMenuResponse): void {
    this.context.commit('setScanSystemMenu', value);
    this.context.commit('updateStorage', this._sorting);
  }

  @Action({ rawError: true })
  public updateRFIDModeScanTarget(value: number): void {
    this.context.commit('setRFIDModeScanTarget', value);
    this.context.commit('updateStorage', this._sorting);
  }

  @Action({ rawError: true })
  public updateOrderNumberModeScanTarget(value: number): void {
    this.context.commit('setOrderNumberModeScanTarget', value);
    this.context.commit('updateStorage', this._sorting);
  }

  @Action({ rawError: true })
  public updateScanSetting(value: ScanSettingResponse): void {
    this.context.commit('setScanSetting', value || {});
    this.context.commit('updateStorage', this._sorting);
  }

  @Action({ rawError: true })
  public updateScanSettingOnLogin(value: ScanSettingResponse): void {
    this.context.commit('setInductionProcessingMode', value?.inductionProcessingMode);
    this.context.commit('updateStorage', this._sorting);
    this.context.commit('setCurrentScanSetting', value || {});
  }

  public get wesNo(): number {
    // const numberWesNo = this._sorting.wesNo;
    return this._sortingSession.wesNo ?? 0;
  }

  get lastChuteNo(): string {
    return this._sortingSession.lastChuteNo;
  }

  get rejectedTask(): boolean | undefined {
    return this._sortingSession.rejectedTask;
  }

  get workInstruction(): WorkInstruction {
    const numberWorkInstruction = this._sorting.workInstruction;
    return numberWorkInstruction;
  }

  get workTypeSorting(): WorkTypeSorting | null {
    const numberWorkTypeSorting = this._sorting.workType;

    return numberWorkTypeSorting;
  }

  get taskTypeSorting(): TaskTypeSorting | null {
    const numberTaskTypeSorting = this._sorting.taskType;

    return numberTaskTypeSorting;
  }

  get scanSystemSetting(): ScanSystemSetting | null {
    const objectSetting = this._sorting.setting;
    return objectSetting;
  }

  get scanSystemFields(): Array<ScanSystemField> | null {
    const listFields = this._sorting.field;
    return listFields;
  }

  get taskTypeName(): string | null {
    return this._sorting.taskTypeName;
  }

  get rejectCreateNewTaskFlag(): number {
    return this._sorting.setting.rejectCreateNewTaskFlag;
  }

  get rejectShowErrorFlag(): number {
    return this._sorting.setting.rejectErrorShowFlag;
  }

  get rejectChuteNaShowErrorFlag(): number {
    return this._sorting.setting.rejectChuteNaShowErrorFlag;
  }

  get scanCancelTaskServiceSettingVisibleFlag(): boolean | undefined {
    return this._sorting.scanCancelTaskServiceSettingVisibleFlag;
  }

  get multiSortChangedQuantityAlert(): boolean | undefined {
    return this._sorting.multiSortChangedQuantityAlert;
  }

  get rfidModeScanTarget(): number | null {
    return this._sorting.rfidModeScanTarget;
  }

  get orderNumberModeScanTarget(): number {
    return this._sorting.orderNumberModeScanTarget;
  }

  get scanSetting(): ScanSettingResponse {
    return this._sorting.scanSetting;
  }

  get currentScanSetting(): ScanSettingResponse {
    return this._currentScanSetting;
  }
}
